// tslint:disable-next-line:no-submodule-imports
import * as faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import * as classNames from 'classnames';
import * as React from 'react';

export default ({
    className,
    style
}: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <h6 className={classNames('loader', className || '')} style={style}>
        <FontAwesomeIcon icon={faSpinner} spin={true} /> Loading
    </h6>
);



// WEBPACK FOOTER //
// ./src/client/components/LoadingSpinner.tsx